export default __webpack_public_path__ + "static/media/retratos-de-adolescentes-felizes-isolados.8d977478.png";